import React from 'react';
import QuizForm from '../components/QuizForm.jsx';

const Quiz = () => {
  return <QuizForm />;
};

export default Quiz;
